import { hrmService } from '@/services/hrmService'
import {
  SET_EDUCATIONAL_INFO_LIST,
  SET_EDUCATIONAL_INFO_DETAILS,
  UNSET_EDUCATIONAL_INFO_DETAILS,
  SET_EDUCATIONAL_INFO_LOADING,
} from '@/store/mutation-types'

// Initial state
const state = {
  educationalInfoList: [],
  educationalInfoDetails: null,
  loading: false,
}

const getters = {
  getEducationalInfoList(state) {
    return state.educationalInfoList
  },
  getEducationalInfoDetails(state) {
    return state.educationalInfoDetails
  },
  getEducationalInfoLoading(state) {
    return state.loading
  },
}

const mutations = {
  [SET_EDUCATIONAL_INFO_LIST](state, data) {
    state.educationalInfoList = data
  },
  [SET_EDUCATIONAL_INFO_DETAILS](state, data) {
    state.educationalInfoDetails = data
  },
  [UNSET_EDUCATIONAL_INFO_DETAILS](state) {
    state.educationalInfoDetails = null
  },
  [SET_EDUCATIONAL_INFO_LOADING](state, loading) {
    state.loading = loading
  },
}

const actions = {
  /**
   * Get educational information list
   */
  getEducationalInfoList({ commit }) {
    commit('SET_EDUCATIONAL_INFO_LOADING', true)
    return new Promise((resolve, reject) => {
      hrmService.getEducationalInfoList()
        .then((response) => {
          if (response.success) {
            commit('SET_EDUCATIONAL_INFO_LIST', response.data)
          }
          commit('SET_EDUCATIONAL_INFO_LOADING', false)
          resolve(response)
        })
        .catch((error) => {
          commit('SET_EDUCATIONAL_INFO_LOADING', false)
          reject(error)
        })
    })
  },

  /**
   * Get educational information by employee ID
   */
  getEducationalInfoByEmployee({ commit }, employeeId) {
    commit('SET_EDUCATIONAL_INFO_LOADING', true)
    return new Promise((resolve, reject) => {
      hrmService.getEducationalInfoByEmployee(employeeId)
        .then((response) => {
          if (response.success) {
            commit('SET_EDUCATIONAL_INFO_LIST', response.data)
          }
          commit('SET_EDUCATIONAL_INFO_LOADING', false)
          resolve(response)
        })
        .catch((error) => {
          commit('SET_EDUCATIONAL_INFO_LOADING', false)
          reject(error)
        })
    })
  },

  /**
   * Get educational information by ID
   */
  getEducationalInfoById({ commit }, id) {
    commit('SET_EDUCATIONAL_INFO_LOADING', true)
    return new Promise((resolve, reject) => {
      hrmService.getEducationalInfoById(id)
        .then((response) => {
          if (response.success) {
            commit('SET_EDUCATIONAL_INFO_DETAILS', response.data)
          }
          commit('SET_EDUCATIONAL_INFO_LOADING', false)
          resolve(response)
        })
        .catch((error) => {
          commit('SET_EDUCATIONAL_INFO_LOADING', false)
          reject(error)
        })
    })
  },

  /**
   * Save or update educational information
   */
  saveEducationalInfo({ commit }, educationalData) {
    commit('SET_EDUCATIONAL_INFO_LOADING', true)
    return new Promise((resolve, reject) => {
      hrmService.saveEducationalInfo(educationalData)
        .then((response) => {
          commit('SET_EDUCATIONAL_INFO_LOADING', false)
          resolve(response)
        })
        .catch((error) => {
          commit('SET_EDUCATIONAL_INFO_LOADING', false)
          reject(error)
        })
    })
  },

  /**
   * Delete educational information
   */
  deleteEducationalInfo({ commit }, id) {
    commit('SET_EDUCATIONAL_INFO_LOADING', true)
    return new Promise((resolve, reject) => {
      hrmService.deleteEducationalInfo(id)
        .then((response) => {
          commit('SET_EDUCATIONAL_INFO_LOADING', false)
          resolve(response)
        })
        .catch((error) => {
          commit('SET_EDUCATIONAL_INFO_LOADING', false)
          reject(error)
        })
    })
  },

  /**
   * Get educational information grouped by level for an employee
   */
  getEducationalInfoGroupedByEmployee({ commit }, employeeId) {
    commit('SET_EDUCATIONAL_INFO_LOADING', true)
    return new Promise((resolve, reject) => {
      hrmService.getEducationalInfoGroupedByEmployee(employeeId)
        .then((response) => {
          if (response.success) {
            commit('SET_EDUCATIONAL_INFO_DETAILS', response.data)
          }
          commit('SET_EDUCATIONAL_INFO_LOADING', false)
          resolve(response)
        })
        .catch((error) => {
          commit('SET_EDUCATIONAL_INFO_LOADING', false)
          reject(error)
        })
    })
  },

  /**
   * Save multiple educational records for an employee
   */
  saveEmployeeEducationalInfo({ commit }, { employeeId, educationalData, files = {} }) {
    commit('SET_EDUCATIONAL_INFO_LOADING', true)
    return new Promise((resolve, reject) => {
      hrmService.saveEmployeeEducationalInfo(employeeId, educationalData, files)
        .then((response) => {
          commit('SET_EDUCATIONAL_INFO_LOADING', false)
          resolve(response)
        })
        .catch((error) => {
          commit('SET_EDUCATIONAL_INFO_LOADING', false)
          reject(error)
        })
    })
  },

  /**
   * Update educational information
   */
  updateEducationalInfo({ commit }, { id, educationalData }) {
    commit('SET_EDUCATIONAL_INFO_LOADING', true)
    return new Promise((resolve, reject) => {
      hrmService.updateEducationalInfo(id, educationalData)
        .then((response) => {
          commit('SET_EDUCATIONAL_INFO_LOADING', false)
          resolve(response)
        })
        .catch((error) => {
          commit('SET_EDUCATIONAL_INFO_LOADING', false)
          reject(error)
        })
    })
  },

  /**
   * Bulk delete educational information
   */
  bulkDeleteEducationalInfo({ commit }, ids) {
    commit('SET_EDUCATIONAL_INFO_LOADING', true)
    return new Promise((resolve, reject) => {
      hrmService.bulkDeleteEducationalInfo(ids)
        .then((response) => {
          commit('SET_EDUCATIONAL_INFO_LOADING', false)
          resolve(response)
        })
        .catch((error) => {
          commit('SET_EDUCATIONAL_INFO_LOADING', false)
          reject(error)
        })
    })
  },

  /**
   * Clear educational information details
   */
  clearEducationalInfoDetails({ commit }) {
    commit('UNSET_EDUCATIONAL_INFO_DETAILS')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
